
import request from '@/utils/request';
export const postForm = (paramap) => {
    return request({
      url: '/jdc-data/contactbook/save',
      method: 'post',
      data: paramap
    })
  }
  